import React, {useEffect} from 'react'
import './pricePlan.scss'
import PPHero from './component/ppHero/PPHero'
import FAQs from './component/FAQs/FAQs'
import Footer from '../../components/footer/Footer'

const PricePlan = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="price_plan">
            <div className="price_plan__wrapper">
                <PPHero/>
                <FAQs/>
                <Footer/>
            </div>
        </div>
    )
}

export default PricePlan
